var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-menu',{staticStyle:{"height":"100%"},attrs:{"default-active":_vm.activeMenu}},_vm._l((_vm.authRoutes),function(menu){return _c('SubMenu',{key:menu.path,attrs:{"menu":menu}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }